import { ReactComponent as Icon } from "../icons/holiday.svg";

const Holiday = ({color, wth, curs, clickFunc}) => {
  return (
    <div>
      <Icon style={({fill: color, width: wth, height: wth, cursor: curs, marginTop: "4px"})} onClick={clickFunc}/>
    </div>
  );
};

export default Holiday;